import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useAtomValue} from 'jotai';

import {isAuthenticatedAtom} from '@atoms/auth';

export const ProtectedRoute = () => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{from: location.pathname}} />;
  }
  return <Outlet />;
};

export const PublicOnlyRoute = () => {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  if (isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
};
